module.exports = __webpack_public_path__ + "img/pexels-min-an-1163194.144f0f89.jpg";